<template>
  <v-dialog v-model="model" max-width="400">
    <template #activator="{ on }">
      <slot name="activator" :on="on" />
    </template>
    <v-card>
      <v-card-title class="pink--text"> Change name </v-card-title>
      <v-card-text>
        <v-form ref="form" @submit.prevent="onSubmit">
          <v-text-field v-model="crud.name" label="New Name" :rules="[rules.required]" />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="pink"
          :loading="loading"
          class="white--text ml-auto"
          depressed
          @click="onSubmit"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { updateCloudAddress } from "@/api/api";
import { rules } from "../../mixins/rulesMixin";

export default {
  props: {
    address: { type: Object, required: true },
    value: Boolean,
  },
  data() {
    return {
      crud: {
        name: this.address.name,
      },
      loading: false,
      rules,
      model: this.value,
    };
  },
  methods: {
    async onSubmit() {
      const form = this.$refs.form;
      if (!form.validate()) return;
      this.loading = true;
      try {
        await updateCloudAddress(this.address, this.crud.name);
        this.address.name = this.crud.name;
        this.model = false;
        form.reset();
      } finally {
        this.loading = false;
      }
    },
  },
  watch: {
    value(val) {
      this.model = val;
    },
    model(val) {
      this.$emit("input", val);
    },
  },
};
</script>
